module.exports = __webpack_public_path__ + "static/media/6_v2.3bac89d6.jpg";